import moment from 'moment'

export const backendDateTimeFormat = 'YYYY-MM-DD'
export const preciseDateTimeFormat = 'YYYY-MM-DD HH:mm:ss'
export const preciseDateTimeFormatDashes = 'YYYY-MM-DD HH-mm-ss'
export const prettyTimeFormat = 'h:mm:ss A'
export const prettyDateFormat = 'MMM DD, YYYY'
export const prettyDateTimeFormat = 'MMM DD, YYYY ⋅ h:mm A'
export const precisePrettyDateTimeFormat = 'MMM DD, YYYY ⋅ HH:mm:ss'
export const prettyDateTimeFormatShort = 'MMM DD, YYYY HH:mm'

export function newDateStringNoTimezone(date) {
  return moment(date).format(backendDateTimeFormat)
}

export function newDateStringNoTimezoneAddOneDay(date) {
  return moment(date).add(1, 'day').format(backendDateTimeFormat)
}

const CONVERT_OFFSET_TO_HOURS_AT = 60
const GMT = /.*GMT.*/
// Default format is 'MMM-DD-YYYY HH:mm A'
// Set excludeUtcText to false to hide the extra UTC offset text (does not hide it from ISO8601 format)
// Default utcOffsetTextPrefix looks like: 'UTC -8.5 hours' or 'UTC -30 minutes' or 'UTC +8.5 hours'
//'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ' → moment can read Greenwich Mean Time

export function formatDate(dateTimeString, formatType, { isUtc } = {}) {
  moment.locale('en')
  let momentDate = isUtc ? moment.utc(dateTimeString).local() : moment(dateTimeString)
  return momentDate.format(formatType || 'MMM-DD-YYYY')
}

export default {
  methods: {
    formatDate,
    formatDateTime(dateTimeString, {
      format,
      excludeUtcText,
      utcOffsetTextPrefix,
    } = {}) {
      if (!format) {
        format = 'MMM-DD-YYYY HH:mm A'
      }
      let parsed
      if (GMT.test(dateTimeString)) {
        parsed = moment.utc(dateTimeString, 'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ')
      } else {
        parsed = moment.utc(dateTimeString)
      }
      moment.locale('en')
      let utcOffsetText = ''

      if (!excludeUtcText) {
        let utcOffsetMinutes = parsed.utcOffset()
        let absUtcOffsetMinutes = Math.abs(utcOffsetMinutes)
        let plural = false
        let preferHours = absUtcOffsetMinutes >= CONVERT_OFFSET_TO_HOURS_AT
        let asHours = 0

        if (preferHours) {
          asHours = utcOffsetMinutes / 60
          plural = Math.abs(asHours) > 1
        } else {
          plural = Math.abs(utcOffsetMinutes) > 1
        }

        if (!utcOffsetTextPrefix) {
          utcOffsetTextPrefix = 'UTC'
        }
        utcOffsetText = utcOffsetTextPrefix
        if (utcOffsetMinutes !== 0) {
          utcOffsetText += ' ' +
            (utcOffsetMinutes > 0 ? '+' : '') +
            (preferHours ?
              `${asHours} hour` : `${utcOffsetMinutes} minute`) +
            (plural ? 's' : '')
        }
      }

      let formatted = parsed.format(format) + ((utcOffsetText && ` (${utcOffsetText})`) || '')
      return formatted
    },
    formatDateForSentinel(dateTimeString) {
      return moment(dateTimeString, 'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ').format(backendDateTimeFormat)
    },
    convertToJavaScriptDate(dateTimeString) {
      return moment(dateTimeString, 'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ').toDate()
    },
    formatDateFromMoment(momentObj, format) {
      if (format) {
        moment.locale('en')
        return momentObj.format(format)
      } else {
        return momentObj.toISOString()
      }
    },
    parseDateTextToMoment(dateText, {
      format,
      utcOffsetMinutes,
    } = {}) {
      var parsedMoment = null
      var parsedDate = null
      var isValid = false
      moment.locale('en')
      if (!format) {
        format = backendDateTimeFormat
      }
      parsedMoment = moment(dateText, format)

      if (typeof utcOffsetMinutes !== 'undefined') {
        parsedMoment.utcOffset(utcOffsetMinutes, true)
      }
      parsedDate = parsedMoment.toDate()
      isValid = parsedMoment.isValid()
      return {
        parsedMoment: parsedMoment,
        parsedDate: parsedDate,
        isValid: isValid,
        formattedText: (isValid ? parsedMoment.format(format) : dateText),
      }
    },
    parseAmbiguousTextToMoment(dateText, {
      outputFormat,
      isUTCString,
    } = {}) {
      let parsedMoment = null
      let parsedDate = null
      let isValid = false
      outputFormat = outputFormat || backendDateTimeFormat
      isUTCString = isUTCString || false
      moment.locale('en')
      parsedMoment = (isUTCString) ?
        moment.utc(dateText) : moment(dateText)
      parsedDate = parsedMoment.toDate()
      isValid = parsedMoment.isValid()
      return {
        parsedMoment: parsedMoment,
        parsedDate: parsedDate,
        isValid: isValid,
        formattedText: (isValid ? parsedMoment.local().format(outputFormat) : dateText),
      }
    },
    isDateBeforeOrSame(dateA, dateB) {
      var momentA = moment.utc(dateA)
      var momentB = moment.utc(dateB)
      return momentA.isBefore(momentB, 'day') || momentA.isSame(momentB, 'day')
    },
    newDateStringNoTimezone(date) {
      return new moment(date).format(backendDateTimeFormat)
    },
    newDateStringNoTimezoneAddOneDay(date) {
      date = moment(date).add(1, 'd')
      return new moment(date).format(backendDateTimeFormat)
    },
    calculateDiff(dateA, dateB) {
      let date1 = moment(dateA)
      let date2 = moment(dateB)
      var duration = moment.duration(date2.diff(date1)) // calculate the difference between the two dates

      var minutes = duration.humanize() // convert the duration to human readable string

      return minutes
    },
  },
}